import type { AddOnDefinition, AddOnType } from '../pricing-data';
import { CheckIcon } from './CheckIcon';

interface AddOnCardProps {
  addOn: AddOnDefinition;
  primaryColor: string;
  onJoinWaitlist: (addOn: AddOnType) => void;
}

export function AddOnCard({ addOn, primaryColor, onJoinWaitlist }: AddOnCardProps) {
  return (
    <div className="bg-gray-50 rounded-3xl border border-dashed border-gray-300 p-6 flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xl font-semibold text-gray-700">{addOn.name}</h3>
        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-600">
          In development
        </span>
      </div>
      <p className="text-sm text-gray-600 mb-4">{addOn.description}</p>

      {/* Price + CTA */}
      <div className="mt-1">
        <span className="block text-5xl sm:text-4xl font-extrabold tracking-tight text-gray-900">
          {addOn.price}
        </span>
        <span className="mt-0.5 block text-sm font-medium text-gray-500">
          {addOn.priceLabel}
        </span>
      </div>
      <div className="mt-4">
        <button
          onClick={() => onJoinWaitlist(addOn.name)}
          className="w-full flex items-center justify-center px-4 py-2.5 border border-gray-300 text-sm font-medium rounded-full text-gray-600 bg-white shadow-sm transition-all hover:border-gray-400 hover:text-gray-700"
        >
          Join waitlist
        </button>
      </div>

      {/* Details */}
      <div className="mt-5 border-t border-gray-200 pt-4">
        <p className="text-sm text-gray-500 mb-3">{addOn.pricingNote}</p>
        <h4 className="text-sm font-semibold text-gray-900 mb-2">Everything included:</h4>
        <ul className="space-y-2 text-sm text-gray-600">
          {addOn.features.map((feature) => (
            <li key={feature.text} className="flex items-start">
              <div className="flex-shrink-0 mt-0.5">
                <CheckIcon color={primaryColor} size="sm" />
              </div>
              <span className="ml-2">{feature.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
